module.exports = __webpack_public_path__ + "img/Thickness.ceb76993.svg";